// @flow
import type { Firestore } from '../types/firebase';
import _createModel from './_model';
import type { Config, Model as ModelType } from './_model';

export default (firestore: Firestore, config?: Config) => _createModel<any>(firestore, {
    collection: 'config',
    statics: {
        constants: Object.freeze({
            VISIBILITY_LVO: 'LVO',
            VISIBILITY_NVO: 'NVO'
        }),

        setStatus: (Model: ModelType<any>, id: string, value: any) => {
            if(!id) {
                throw new Error('Parameter id must be defined');
            }
            console.log('setting id', id, value);

            Model.findById('status')
                .then(doc => {
                    let oldValue = {};

                    if(doc.exists) {
                        oldValue = doc.data()[id] || {};
                    }

                    Model.findByIdAndUpdate('status', {
                        [id]: {
                            ...oldValue,
                            value,
                            updatedAt: Date.now()
                        }
                    }, {
                        upsert: true
                    });
                });
        }
    }
}, config);